module.exports = __webpack_public_path__ + "f91a32cd0b4dbef6a075e4075b3c81c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_3_2023_chart.png
// module id = 1686
// module chunks = 0